export default class Staff {
  constructor() {
    this.name = new String();
    this.position = new String();
    this.telephone = new String();
    this.mail = new String();
  }
}
